var _jsxFileName = "/codebuild/output/src2937227346/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/register/CheckYourEmail/index.tsx";
import React, { useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import { InformationalScreen, Stack } from '@adc/parallax-component-library';
import { ApiStatus, ErrorCode } from 'Constants';
import { useApiError, useAuth, useClickContinueEmailVerificationButton, useResendVerificationEmail } from 'Hooks';
import { Footer, MainContainer, TopHeaderBackArrow } from 'Components/utility';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
import CheckYourEmailComponents from './components';
const mapStateToProps = ({
  auth: {
    account_id
  },
  env: {
    installationId,
    osType,
    osVersion,
    app,
    appVersion
  }
}) => {
  return {
    account_id,
    installationId,
    osType,
    osVersion,
    app,
    appVersion
  };
};
const connector = connect(mapStateToProps);
const CheckYourEmail = ({
  data: {
    password,
    email
  },
  installationId,
  osType,
  osVersion,
  app,
  appVersion,
  account_id
}) => {
  const {
    showApiErrorModal,
    showNetworkErrorModal
  } = useApiError();
  const {
    showCountryRegionError
  } = useAuth();
  useEffect(() => {
    if (!password || !email) {
      mediator.publish('router:navigate', '/login');
    }
  }, [email, password]);
  const handleGoBack = () => {
    mediator.publish('router:back');
  };
  const handleApiRequestError = useCallback(error => {
    switch (error.status) {
      case ApiStatus.BAD_REQUEST:
        {
          var _error$response;
          const code = (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data.code;
          if (code === ApiStatus.UNSUPPORTED_COUNTRY || code === ApiStatus.WRONG_REGION) {
            showCountryRegionError();
            return;
          }
          break;
        }
      case ApiStatus.UNAUTHORIZED:
        {
          mediator.publish('router:navigate', '/login');

          // TODO: Show a better auth session expired modal (this was implemented too close to the release for new strings to be added)
          showApiErrorModal();
          break;
        }
      default:
        error.code === ErrorCode.NETWORK_ERROR ? showNetworkErrorModal() : showApiErrorModal();
    }
  }, [showApiErrorModal, showCountryRegionError, showNetworkErrorModal]);
  const {
    handleResendEmailButtonClick
  } = useResendVerificationEmail({
    account_id,
    osType,
    osVersion,
    app,
    appVersion,
    handleApiRequestError
  });
  const {
    handleContinueEmailVerificationButtonClick,
    isLoading
  } = useClickContinueEmailVerificationButton({
    account_id,
    osType,
    osVersion,
    app,
    appVersion,
    installationId,
    handleApiRequestError
  });
  return /*#__PURE__*/React.createElement(MainContainer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 113,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(InformationalScreen, {
    topNavigationProps: {
      title: i18n.t('CheckYourEmailRegistration.title'),
      animatedTitle: true,
      buttonStart: {
        element: /*#__PURE__*/React.createElement(TopHeaderBackArrow, {
          testID: "Auth.action-go-back",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 119,
            columnNumber: 22
          }
        }),
        onPress: handleGoBack
      }
    },
    testID: "CheckYourEmail",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 114,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(InformationalScreen.Page, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 125,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(InformationalScreen.Content, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 126,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    marginTop: -8,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 127,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(CheckYourEmailComponents.Content, {
    email: email,
    onButtonPress: handleResendEmailButtonClick,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 128,
      columnNumber: 15
    }
  }))), /*#__PURE__*/React.createElement(InformationalScreen.Footer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 134,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Footer, {
    buttonLabel: i18n.t('Global.microcopy.common.continue'),
    onButtonPress: handleContinueEmailVerificationButtonClick,
    buttonTestID: "CheckYourEmailRegistration.continueButton",
    disabled: isLoading,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 135,
      columnNumber: 13
    }
  })))));
};
export default connector(CheckYourEmail);